var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Orders",
    "data-name": "Icon / Orders",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assignment_turned_in-black-18dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,20H2a2.619,2.619,0,0,1-.4-.03,2,2,0,0,1-1.01-.55,2.108,2.108,0,0,1-.43-.64A2.054,2.054,0,0,1,0,18V4a1.917,1.917,0,0,1,.16-.77A2.022,2.022,0,0,1,1.6,2.04,1.712,1.712,0,0,1,2,2H6.18A2.988,2.988,0,0,1,11.82,2H16a2,2,0,0,1,2,2V18A2,2,0,0,1,16,20ZM2,4V18H16V4ZM9,1.75a.75.75,0,1,0,.75.751A.751.751,0,0,0,9,1.75ZM7,16H7L3,12,4.41,10.59,7,13.17l6.59-6.59L15,8,7,16Z",
    transform: "translate(3 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon-orders.b01363180b73adf3b916a76b027498f6.svg";
export { ForwardRef as ReactComponent };